import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class NotesAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getById(id, router) {
    const url = `/api/notes/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getByTargetUserId(userId, router) {
    const url = `/api/notes/targetUser/${userId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getByTargetUserAndNoteTypeIds(userId, noteTypeId, router) {
    const url = `/api/notes/targetUser/${userId}/noteType/${noteTypeId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getByTargetTaskId(taskId, router) {
    const url = `/api/notes/targetTask/${taskId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getByTargetEventAndNoteTypeIds(eventId, noteTypeId, router) {
    const url = `/api/notes/targetEvent/${eventId}/noteType/${noteTypeId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(params, router) {
    const url = "/api/notes";
    return this.CommonAPIService.postCall(url, params, router);
  }
  delete(id, router) {
    const url = `/api/notes/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  update(task_id, params, router) {
    const url = `/api/notes/${task_id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  getNoteTypeOptions(router) {
    const url = "/api/notes/noteTypeOptions";
    return this.CommonAPIService.getCall(url, "", router);
  }
}
export default NotesAPIService;
